import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

import { renderableType } from '../proptypes/prop-types';
import { buildClassNameModifiers, buildClassNames } from '../util/utils';
import './nimbusLink.scss';

const blockBaseClassName = 'link';
const iconClassName = 'link__icon';

export const NimbusLink = ({
                children,
                className,
                component,
                external,
                ...other
              }) => {
  const CompType = component || 'a';
  const blockClassName = buildClassNames(
    className,
    buildClassNameModifiers(blockBaseClassName, { external }),
    blockBaseClassName,
  );
  return (
    <CompType role='link' className={blockClassName} {...other} >
      {children}
      {external && <FontAwesomeIcon className={iconClassName} icon={faExternalLinkAlt} />}
    </CompType>
  );
};

NimbusLink.propTypes = {
  /** @ignore */
  children: renderableType,
  /** @ignore */
  className: PropTypes.string,
  /** Component to be rendered as a link */
  component: renderableType,
  /** Indicates that the link leads to an external site */
  external: PropTypes.bool,
};

NimbusLink.defaultProps = { external: false };